import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-dashboard-sales-average-purchase-card',
  templateUrl: './dashboard-sales-average-purchase-card.component.html',
  styleUrls: ['./dashboard-sales-average-purchase-card.component.scss']
})
export class DashboardSalesAveragePurchaseCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('average-purchase-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('average-purchase-counts-spinner');
      this.showCounter = true;
      this.count = this.data;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('average-purchase-counts-spinner');
    }
  }

}
